import { render, staticRenderFns } from "./ViewTheft.vue?vue&type=template&id=5882420e&scoped=true"
import script from "./ViewTheft.vue?vue&type=script&lang=js"
export * from "./ViewTheft.vue?vue&type=script&lang=js"
import style0 from "./ViewTheft.vue?vue&type=style&index=0&id=5882420e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5882420e",
  null
  
)

export default component.exports